import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface TestimonialCardProps {
  name: string;
  role: string;
  organization: string;
  image: string;
  alt: string;
  testimonial: string;
  rating: number;
}

export default function TestimonialCard({
  name,
  role,
  organization,
  image,
  alt,
  testimonial,
  rating,
}: TestimonialCardProps) {
  return (
    <div className="bg-white rounded-2xl p-6 shadow-md border border-gray-100 hover:shadow-lg hover:border-[#42AF47]/30 transition-all duration-300">
      <div className="flex items-center space-x-4 mb-5">
        <div className="relative w-16 h-16 rounded-full overflow-hidden flex-shrink-0 ring-2 ring-[#42AF47]/20">
          <AppImage
            src={image}
            alt={alt}
            fill
            className="object-cover"
            sizes="64px"
          />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-lg font-heading font-semibold text-gray-900 truncate">
            {name}
          </h4>
          <p className="text-sm text-gray-600 truncate">{role}</p>
          <p className="text-xs text-[#42AF47] truncate font-medium">
            {organization} · Verified User
          </p>
        </div>
      </div>

      <div className="flex items-center space-x-1 mb-5">
        {[...Array(5)].map((_, index) => (
          <Icon
            key={index}
            name="StarIcon"
            variant={index < rating ? 'solid' : 'outline'}
            size={16}
            className={index < rating ? 'text-[#42AF47] fill-current' : 'text-gray-300'}
          />
        ))}
      </div>

      <p className="text-gray-700 leading-relaxed text-base">
        “{testimonial}”
      </p>
    </div>
  );
}